import { createSelector } from "@ngrx/store";
import { AppState } from "../../app.state";
import { IDetalleTema } from "../../interfaces/temas";
import { INuevaEntrada } from "../../interfaces/entradas";

export const selectTemasState = (state: AppState) => state.acuerdoSeleccionado;
export const selectAcuerdoSelected = createSelector(
  selectTemasState,
  (state) => state
);

export const selectAcuerdoSelectedAcuerdo = createSelector(
  selectTemasState,
  (state) => state.acuerdo
);
export const selectAcuerdoTemas = createSelector(
  selectTemasState,
  (state) => state.temas
);

export const selectArchivosemas = createSelector(
  selectTemasState,
  (state) => state.archivos
);

export const selectStatusAcuerdo = createSelector(
  selectTemasState,
  (state) => state.status
);

export const selectArchivosPorTema = (idTema: string, idEntrada: string) =>
  createSelector(selectAcuerdoTemas, (acuerdoTemas: IDetalleTema[]) => {
    const tema = acuerdoTemas.find((tema) => tema.id === idTema);
    if (tema) {
      const entrada = tema.entradas.find(
        (entrada: INuevaEntrada) => entrada.idEntrada === idEntrada
      );
      return entrada ? entrada.archivos : [];
    }
    return [];
  });
